module.exports = __webpack_public_path__ + "img/myJeep-cj7.d63455ed.jpg";